import script from "./StatisticRemise.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticRemise.vue?vue&type=script&setup=true&lang=js"

import "./StatisticRemise.vue?vue&type=style&index=0&id=eacae9ee&lang=css"

const __exports__ = script;

export default __exports__